export class Assure {
  nom: string;
  prenom: string;
  adresse?: string;
  adresse2?: string;
  adresse3?: string;
  codePostal?: string;
  ville?: string;
  nir?: string;
  numeroOrganisme?: number;

  constructor(
    nom: string,
    prenom: string,
    adresse?: string,
    adresse2?: string,
    adresse3?: string,
    codePostal?: string,
    ville?: string,
    nir?: string,
    numeroOrganisme?: number
  ) {
    this.nom = nom;
    this.prenom = prenom;
    this.adresse = adresse;
    this.adresse2 = adresse2;
    this.adresse3 = adresse3;
    this.codePostal = codePostal;
    this.ville = ville;
    this.nir = nir;
    this.numeroOrganisme = numeroOrganisme;
  }

  static factory(assurerAPI: AssureAPI): Assure {
    return new Assure(
      assurerAPI.Nom,
      assurerAPI.Prenom,
      assurerAPI.Adresse1,
      assurerAPI.Adresse2,
      assurerAPI.Adresse3,
      assurerAPI.CodePostale,
      assurerAPI.Ville,
      assurerAPI.NumeroSS,
      assurerAPI.LiensOrganismes?.LienOrganisme instanceof Array
        ? assurerAPI.LiensOrganismes?.LienOrganisme?.[0]?.Organisme
        : assurerAPI.LiensOrganismes?.LienOrganisme?.Organisme,
    );
  }
}

export type AssureAPI = {
  Nom: string;
  Prenom: string;
  Adresse1: string;
  Adresse2: string;
  Adresse3: string;
  CodePostale: string;
  Ville: string;
  NumeroSS: string;
  LiensOrganismes?: {
    LienOrganisme?:
      | [
          {
            Organisme: number;
          },
        ]
      | {
          Organisme: number;
        };
  };
};
